export const LOCAL = 'local'
export const QA = 'qa'
export const UAT = 'uat'
export const PRODUCTION = 'prod'
export const MAX_TIME_FOR_RECONNECT = 300000
export const ODDS_V2 = 'odds-v2-service'

export const environment = {
  [LOCAL]: {
    env: QA,
    baseUrl: '',
    siteDomain: 'odds-widget',
    liveOdds: 'wss://live-odds.ws.qa.us-east-1.advisionfeeds.com:443',
    endpoint:
      'https://ms.qa-us-east-1.bookmakersreview.com/odds-v2/odds-v2-service',
    widgetDomain: 'https://widget.qa-us-east-1.bookmakersreview.com/',
    maxTimeForReconnect: MAX_TIME_FOR_RECONNECT,
  },
  [QA]: {
    env: QA,
    baseUrl: '',
    siteDomain: 'odds-widget',
    liveOdds: 'wss://live-odds.ws.qa.us-east-1.advisionfeeds.com:443',
    endpoint:
      'https://ms.qa-us-east-1.bookmakersreview.com/odds-v2/odds-v2-service',
    widgetDomain: 'https://widget.qa-us-east-1.bookmakersreview.com/',
    maxTimeForReconnect: MAX_TIME_FOR_RECONNECT,
  },
  [UAT]: {
    env: UAT,
    baseUrl: '',
    siteDomain: 'odds-widget',
    liveOdds: 'wss://liveodds.uat.us-east-1.bookmakersreview.com:443',
    endpoint:
      'https://ms.uat.us-east-1.advisionfeeds.com/odds-v2/odds-v2-service',
    widgetDomain: 'https://widget.uat-us-east-1.bookmakersreview.com/',
    maxTimeForReconnect: MAX_TIME_FOR_RECONNECT,
  },
  [PRODUCTION]: {
    env: PRODUCTION,
    baseUrl: '',
    siteDomain: 'odds-widget',
    liveOdds: 'wss://liveodds.production-us-east-1.bookmakersreview.com:443',
    endpoint:
      'https://ms.production-us-east-1.bookmakersreview.com/ms-odds-v2/',
    widgetDomain: 'https://widget.production-us-east-1.bookmakersreview.com/',
    maxTimeForReconnect: MAX_TIME_FOR_RECONNECT,
  },
}
